import { Box, Button } from "@mui/material";
import { useState, useEffect } from "react";
import { useSelector, shallowEqual } from "react-redux";
import { useNavigate } from "react-router-dom";
import { IState } from "../../lib/store";
import CertInfosModal from "../CertInfosModal";
import DigitalCert from "../DigitalCert";
import PrintDoc from "../PrintDoc";
import SelectDiplomaVersion from "../SelectDiplomaVersion";
import { getCertificate, isSystemAdmin } from "../../lib/helper";
import { ICertificate } from "../../entities/certificates";

interface IProps {
    certificate: ICertificate;
}


export const Certificate: React.FC<IProps> = ({certificate}) => {
    const [openMetadata, setOpenMetadata] = useState<boolean>(false);
    const user = useSelector((state: IState) => state.auth.profile, shallowEqual)!;
    const [templateVersion, setTemplateVersion] = useState('v1');
    const navigate = useNavigate();

    useEffect(() => {
        window.scrollTo(0, 0);
        if (!certificate) {
            navigate('/');
        }
    }, [certificate]);

    const getStatus = () => {
        switch(certificate?.certified) {
            case true:
            return <span style={{color: 'green'}}>Active</span>
            case false:
            return <span style={{color: 'orange'}}>En cours de certification</span>
        }
    }


    return (
        <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            gap={2}
            height="100%"
        >
            <Box width="100%" display="flex" justifyContent="space-between" className="cert-prev">
                {
                    isSystemAdmin(user.id) && (
                        <div style={{flex: 1}}>
                            <Button style={{flex: 1}} color="info" variant="outlined" onClick={() => setOpenMetadata(true)} >Detail</Button>
                        </div>
                    )
                }
                <div style={{display: 'flex', alignItems: 'center'}}>
                    <span style={{paddingRight: '1rem', marginRight: '1rem', borderRight: certificate?.certified ? 'solid 2px' : undefined, color: '#607489'}}>
                        <strong>Statut:</strong><span className="cert-status">{getStatus()}</span>
                    </span>
                </div>
                <div style={{display: 'flex', alignItems: 'center', gap: 4}}>
                    {/* {certificate?.certified && (
                        <PrintDoc certificate={certificate!} />
                    )} */}
                    <SelectDiplomaVersion version={templateVersion} grade={certificate!.grade} onSelect={(version) => setTemplateVersion(version)} />
                    <PrintDoc templateVersion={templateVersion} certificate={certificate!} />
                </div>
            </Box>


            <Box height="100%" width="100%">
                {certificate && <DigitalCert certificate={certificate!} />}
            </Box>


            <CertInfosModal open={openMetadata} close={() => setOpenMetadata(false)} certificate={certificate!} />

        </Box>
    )
}